import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['phoneNumber', 'isGlobalPlayer']),
    ...mapGetters('auth', ['isLoggedIn'])
  }
}
